import React from 'react'

const Tree = () => {
  return (
    <div>
        <iframe src="https://visualgo.net/en/bst" width="100%" height="920px" title="Tree"></iframe>
    </div>
  )
}

export default Tree